import { render } from "./MyHeader.vue?vue&type=template&id=0503fd0a"
import script from "./MyHeader.vue?vue&type=script&lang=js"
export * from "./MyHeader.vue?vue&type=script&lang=js"

import "./MyHeader.vue?vue&type=style&index=0&id=0503fd0a&lang=css"

import exportComponent from "D:\\crazycatfrontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__